<div class="flex flex-col justify-start items-start gap-4 w-full mt-5">
	<ng-container *ngFor="let question of faqs.faqQuestionList; let i = index">
		<div class="w-full flex justify-center items-start gap-3">
			<div class="bg-gray-200 p-2 pb-0 rounded-md">
				<span class="material-symbols-outlined">live_help</span>
			</div>
			<div  class="w-full flex flex-col justify-start items-start ">
				<div (click)="triggerFaqHeading(i)"
					 class="w-full flex justify-between items-center gap-2.5 cursor-pointer">
					<h4  class="font-bold ">{{question.question}}</h4>

					<span *ngIf="activeIndex === i" class="material-symbols-outlined close">
								arrow_drop_up
							</span>
					<span *ngIf="activeIndex !== i"
						  class="material-symbols-outlined open">
								arrow_drop_down
							</span>
				</div>
				<div class=" fb-faq-body mt-1" [ngClass]="activeIndex === i? 'active': ''">
					<p  class="">{{question.answer}}</p>
				</div>
			</div>
		</div>
	</ng-container>
</div>
